import { VALIDATION } from './validation'
import { COUNTRIES } from './countries'
import { REGISTRATION_DETAILS } from './registration-details'

const LOCALE = {
    translation: {
        validation: VALIDATION,
        countries: COUNTRIES,
        registrationDetails: REGISTRATION_DETAILS,
    }
}

export default LOCALE
